import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LazyLoadEvent } from "primeng/api";
import { UserService, HttpclientService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SchoolSettingsService } from "../services/adminsettings.service";
import * as moment from "moment";

@Component({
	selector: "app-semester-setup",
	templateUrl: "./semester-setup.component.html",
	styleUrls: ["./semester-setup.component.css"],
})
export class SemesterSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private router: Router,
		private userService: UserService,
		private httpclientService: HttpclientService,
		private schoolSettingsService: SchoolSettingsService
	) {}
	schoolList: any = [];
	option = {
		schoolID: 0,

		//  StartDate: new Date(),
		//  EndDate: new Date(),
	};

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	pagerows: any = 10;
	pagefirst: any = 0;

	subscription: any;
	loading: any = false;

	ngOnInit() {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});

		this.user = this.userService.getCurrentUser();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response: any) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "Select a School",
					});
				} else {
					this.option.schoolID = this.schoolList[0].schoolID;
					this.SemesterGetList();
				}
			},
			(error) => {}
		);
	}
	onSchoolChange(value) {
		//this.loadSchoolist();
		this.resetValidationInfo();
		this.option.schoolID = value;
		this.SemesterGetList();
	}

	onChangeStartDate(record) {
		// var isafter = moment(record.StartDateText).isAfter(moment(record.EndDate));
		// if (isafter) {
		//   this.errorMessage = "The end date must be greater than the start date";
		//   return;
		// }

		//alert(record.StartDateText)

		// record.errorMessage = ""
		// if (record.StartDateText) {
		//   var myDate = record.StartDateText

		//   if (myDate.length == 15) {
		//     myDate = moment(record.StartDateText)
		//    // myDate=moment(record.StartDate)

		//   }
		//   record.StartDate = myDate
		//   record.StartDateText = moment(myDate);
		//   record.StartDate = moment( record.StartDateText)
		//   record.EndDate =moment( record.EndDateText)
		//   if ((record.StartDate) > (record.EndDate)) {
		//     record.errorMessage = "Start Date must be before End Date"
		//   }
		// } else {
		//   record.StartDate = new Date();
		// }

		record.errorMessage = "";

		record.errorMessage = "";
		if (record.StartDateText) {
			var myDate = record.StartDateText;
			if (myDate.length == 8) {
				myDate = new Date(moment(new Date()).format("MM/DD/YYYY") + " " + record.StartDateText);
			}
			record.StartDate = myDate;
			record.StartDateText = moment(myDate).format("MM/DD/YYYY");
			// record.StartDate = new Date(moment(new Date()).format('MM/DD/YYYY') + " " + record.StartDateText);
			// record.EndDate = new Date(moment(new Date()).format('MM/DD/YYYY') + " " + record.EndDateText);

			record.StartDate = new Date(record.StartDateText);
			record.EndDate = new Date(record.EndDateText);

			if (moment(record.StartDate) > moment(record.EndDate)) {
				record.errorMessage = "Start Date must be before End Date";
			}
		} else {
			record.StartDate = null;
		}
	}

	onChangeEndDate(record) {
		record.errorMessage = "";

		if (record.EndDateText) {
			var myDate = record.EndDateText;

			if (myDate.length == 8) {
				myDate = new Date(moment(new Date()).format("MM/DD/YYYY") + " " + record.EndDateText);
			}
			record.EndDate = myDate;
			record.EndDateText = moment(myDate).format("MM/DD/YYYY");
			// record.StartDate = new Date(moment(new Date()).format('MM/DD/YYYY') + " " + record.StartDateText);
			// record.EndDate = new Date(moment(new Date()).format('MM/DD/YYYY') + " " + record.EndDateText);

			record.StartDate = new Date(record.StartDateText);
			record.EndDate = new Date(record.EndDateText);

			if (moment(record.StartDate) > moment(record.EndDate)) {
				record.errorMessage = "Start Date must be before End Date";
			}
		} else {
			record.EndDate = null;
		}
	}

	lstAllRecords: any = [];
	SelectedSemester: any;

	SemesterGetList() {
		if (!this.option.schoolID) {
			this.lstAllRecords = [];
			return;
		}

		this.loading = true;

		var result = this.schoolSettingsService.SemesterList(this.option.schoolID);
		result.subscribe((response) => {
			this.lstAllRecords = response;

			$.each(this.lstAllRecords, function (index, result) {
				result.StartDateText = moment(result.StartDate).format("MM/DD/YYYY");
				result.EndDateText = moment(result.EndDate).format("MM/DD/YYYY");
				result.saved = false;
				result.issaving = false;
				result.errorMessage = "";
			});

			this.loading = false;
		});
	}
	Save(record) {
		this.isProcessing = true;

		record.saved = false;
		record.issaving = true;

		var StartDate = moment(record.StartDate).format("MM/DD/YYYY hh:mm A");
		var EndDate = moment(record.EndDate).format("MM/DD/YYYY hh:mm A");

		var result = this.schoolSettingsService.SemesterUpdate(record.SemesterID, StartDate, EndDate);

		result.subscribe((response) => {
			record.issaving = false;
			record.saved = true;
			setTimeout(function () {
				record.saved = false;
			}, 2000);

			this.selectService.SchoolRefresh("refresh");

			this.isProcessing = false;
		});
	}

	testvalidationpassed = false;
	testvalidationfailed = false;
	testvalidationerrormessage = "";

	private resetValidationInfo() {
		this.testvalidationpassed = false;
		this.testvalidationfailed = false;
		this.testvalidationerrormessage = "";
	}

	Test() {
		this.isProcessing = true;

		this.resetValidationInfo();

		var result = this.schoolSettingsService.SemesterValidity(this.option.schoolID);

		result.subscribe((response: any) => {
			this.testvalidationerrormessage = response;

			if (response) {
				this.testvalidationpassed = false;
				this.testvalidationfailed = true;
			} else {
				this.testvalidationpassed = true;
				this.testvalidationfailed = false;
			}

			var that = this;
			setTimeout(function () {
				that.resetValidationInfo();
			}, 2000);

			this.isProcessing = false;
		});
	}

	onRefresh() {
		this.resetValidationInfo();
		this.SemesterGetList();
	}

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSemester = val.data;
	}
	onRowUnselect(val) {
		this.SelectedSemester = null;
	}
	onRowDblClick(Semester) {
		this.SelectedSemester = Semester;
	}
	////////////////////////////////////////////
}
